"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAvatarPopupContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
exports.StyledAvatarPopupContainer = styled_components_1.default.div(function () { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-left: 1rem;\n\n    [data-testid='popover'] {\n      max-height: 80vh;\n      overflow-y: auto;\n    }\n\n    [data-testid='avatarCardWithKebab'] {\n      z-index: 1;\n    }\n\n    [data-testid='window-avatar-container'] {\n      height: auto;\n    }\n  "], ["\n    margin-left: 1rem;\n\n    [data-testid='popover'] {\n      max-height: 80vh;\n      overflow-y: auto;\n    }\n\n    [data-testid='avatarCardWithKebab'] {\n      z-index: 1;\n    }\n\n    [data-testid='window-avatar-container'] {\n      height: auto;\n    }\n  "]))); });
var templateObject_1;
